export default function($) {
  // Product filters nav on mobile

  var productNav = $('.js-product-filters-items'),
      openProductNav = $('.js-product-filters-trigger'),
      closeProductNav = $('.js-product-filters-close');

  openProductNav.on('click', function() {
    if( !productNav.hasClass('open') ) {
      productNav.addClass('open');
      openProductNav.find('svg').css('fill', '#D42D26');
      $('body').css('max-height', '100%');
      $('body').css('overflow', 'hidden');
    }
  });

  closeProductNav.on('click', function() {
    if( productNav.hasClass('open') ) {
      productNav.removeClass('open');
      openProductNav.find('svg').css('fill', '#1D1B1B');
      $('body').css('max-height', 'none');
      $('body').css('overflow', 'initial');
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.product-filters').length) {
      if (productNav.hasClass("open")) {
        productNav.removeClass('open');
        openProductNav.find('svg').css('fill', '#1D1B1B');
        $('body').css('max-height', 'none');
        $('body').css('overflow', 'initial');
      }
    }
  });
}
